var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{staticClass:"survey-layout",style:(_vm.cssVars)},[_c('v-container',{staticClass:"surveyjs-root-container",class:_vm.cssClasses},[_c('survey',{attrs:{"survey":_vm.survey}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }